import { useState } from 'react';
import { reportBuilderApi } from '../api/reportBuilderApi';

export type DownloadStatus = 'idle' | 'loading' | 'success' | 'error';

/**
 * GET /api/eraf/report-builder/generations/{genId}/download — 이력 재다운로드
 * audit-log excel 다운로드 패턴과 동일하게 구현
 */
export function useDownloadGeneration() {
  const [statusMap, setStatusMap] = useState<Record<number, DownloadStatus>>({});
  const [errorCode, setErrorCode] = useState<string | undefined>();

  async function doDownload(genId: number) {
    setStatusMap((prev) => ({ ...prev, [genId]: 'loading' }));
    setErrorCode(undefined);
    try {
      const { data, filename } = await reportBuilderApi.downloadGeneration(genId);
      const url = URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setStatusMap((prev) => ({ ...prev, [genId]: 'success' }));
      setTimeout(() => setStatusMap((prev) => ({ ...prev, [genId]: 'idle' })), 3000);
    } catch (err) {
      const apiErr = err as { code?: string };
      setErrorCode(apiErr.code ?? 'UNKNOWN');
      setStatusMap((prev) => ({ ...prev, [genId]: 'error' }));
    }
  }

  function getStatus(genId: number): DownloadStatus {
    return statusMap[genId] ?? 'idle';
  }

  return { doDownload, getStatus, errorCode };
}
